import { BydUserRightInterface } from '../interfaces/byd-user-right.interface';

export class BydUserRight {
  /**
   * The right id
   */
  public id = -1;

  /**
   * The right name
   */
  public name = '';

  /**
   * The right date
   */
  public date = '';

  /**
   * The right parent
   */
  public parent = -1;

  /**
   * The right value
   */
  public right = '';

  /**
   * The right identifier
   */
  public identifier = -1;

  /**
   * The right file
   */
  public file = '';

  /**
   * The right local
   */
  public local: boolean;

  /**
   * The right module status
   */
  public isModule: boolean;

  /**
   * The rights
   */
  public rights: BydUserRight[];

  /**
   * Creates an instance of BydUserRight.
   *
   * @param jsonData the user rigth data
   */
  constructor(jsonData: BydUserRightInterface) {
    this.id = jsonData.modules_id;
    this.name = jsonData.name;
    this.date = jsonData.modules_date;
    this.parent = jsonData.modules_parent;
    this.right = jsonData.modules_droits;
    this.identifier = jsonData.modules_identifer;
    this.file = jsonData.modules_fichier;
    this.local = jsonData.modules_local ? jsonData.modules_local >= 1 : this.local;
    this.isModule = jsonData.isModule ? jsonData.isModule >= 1 : this.isModule;
    this.rights = jsonData.rights
      ? jsonData.rights.map((right: BydUserRightInterface) => new BydUserRight(right))
      : this.rights;
  }
}
